import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Tuscaloosa, AL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through the Tuscaloosa Main Post Office can take 2–6 months, especially during busy study abroad and summer travel seasons. For UA students with confirmed study abroad programs, MBUSI engineers with Germany travel, and Northport families with booked trips, that timeline simply does not work.",
  },
  {
    q: "Can University of Alabama students get expedited passports for study abroad?",
    a: "Absolutely. UA students are one of our most common client types in Tuscaloosa. The Capstone International Center manages programs in the UK, Germany, Spain, Australia, and dozens of other countries. Students often realize their passport is expired when they receive their study abroad acceptance letters — sometimes just weeks before departure. We handle expedited renewals and first-time applications for UA, Stillman College, and Shelton State students on compressed timelines.",
  },
  {
    q: "What if my passport expires before a Mercedes-Benz trip to Germany?",
    a: "This is a common scenario for MBUSI employees. The Vance plant employs over 6,000 workers, and engineers, managers, and executives travel regularly to Stuttgart for product launches, technical training, and executive meetings. These trips are often scheduled on short notice when project timelines shift. Standard mail-in renewal takes far too long — we recommend expedited processing as soon as your travel is confirmed.",
  },
  {
    q: "Where is the Tuscaloosa passport acceptance facility?",
    a: "The Tuscaloosa Main Post Office at 2112 5th St E is the primary passport acceptance facility. Hours are Monday–Friday 9:00 AM–4:00 PM. The Northport Post Office also accepts applications. However, these facilities only accept applications — they do not process expedited or emergency requests. For fast processing, you need a registered courier service.",
  },
  {
    q: "Can Northport and Duncanville residents use your services?",
    a: "Yes. Northport, Duncanville, Holt, Coaling, Cottondale, and all West Alabama communities are within our service area. Since we operate remotely, your physical location in the Tuscaloosa metro area does not affect processing speed. Ship your documents overnight from anywhere in Tuscaloosa County, and we handle the rest. Most clients receive their passports within 2–9 business days.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Tuscaloosa travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Tuscaloosa, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in West Alabama.",
  },
  {
    q: "What do I need for a child passport in Tuscaloosa?",
    a: "For minors under 16, both parents must appear with the child at an acceptance facility, or one parent with a notarized DS-3053 consent form. Bring proof of citizenship, a passport photo, and ID for both parents. This is the #1 cause of child passport delays in Tuscaloosa.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability. As a registered courier, we offer rates typically 30–100% lower than FedEx, Staples, and other third-party resellers.",
  },
];

export default function TuscaloosaFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Tuscaloosa and West Alabama travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}